import { render, staticRenderFns } from "./TechTreeItem.vue?vue&type=template&id=5deacb8c&scoped=true&"
import script from "./TechTreeItem.vue?vue&type=script&lang=js&"
export * from "./TechTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TechTreeItem.vue?vue&type=style&index=0&id=5deacb8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deacb8c",
  null
  
)

export default component.exports